import { PawPrint, Menu } from "lucide-react";
import logoNoxzi from "../../images/DA_Savoinimaux/logo.webp";

export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-black/6 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <div className="flex items-center gap-4">
            <img
              src={logoNoxzi}
              alt="Logo Savoinimaux"
              className="h-12 w-auto object-contain"
              loading="lazy"
            />

          <div>
            <p className="text-base font-semibold tracking-[0.35em] text-[#111111]">
              SAVOINIMAUX
            </p>
            <p className="text-[10px] uppercase tracking-[0.42em] text-black/45">
              Depuis plus de 12ans
            </p>
          </div>
        </div>

        <nav className="hidden items-center gap-8 text-sm text-black/65 lg:flex">
          <a href="/" className="transition hover:text-red-600">
            Accueil
          </a>
          <a href="/#mission" className="transition hover:text-red-600">
            Mission
          </a>
          <a href="/#stories" className="transition hover:text-red-600">
            Histoires
          </a>
          <a href="/partenaires" className="transition hover:text-red-600">
            Partenaires
          </a>
          <a href="/#contact-form" className="transition hover:text-red-600">
            Contact
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/#engagement"
            className="hidden rounded-full bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_40px_rgba(220,38,38,0.18)] transition hover:bg-red-500 lg:inline-flex"
          >
            Faire un don
          </a>

          <button className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white lg:hidden" aria-label="Ouvrir le menu">
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}